/**
 * Terminus NavItem Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { TooltipDirective } from '@terminus-ui/tooltip';

import { NavItem } from '../../models/nav.model';
import { isNavLinkPipe, isNavMenuPipe } from '../../pipes/nav.pipes';

@Component({
  selector: 'tux-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    isNavMenuPipe,
    TooltipDirective,
    RouterModule,
    isNavLinkPipe,
    isNavMenuPipe,
  ],
})
export class NavItemComponent {
  @Input() navItem: NavItem;
  @Input() active?: boolean;
  faCaretRight = faCaretRight;
}
